import React from "react";
import { Result, Button } from "antd";
import useTranslation from "../../intl/useTranslation";
import { ErrorBoundary } from "react-error-boundary";
import { fbFunctions } from "../../data/Firebase";
import { httpsCallable } from "firebase/functions";

interface AuditErrorBoundaryProps {
	children: React.ReactNode;
	influencerId: string;
	network: string;
}

const AuditErrorFallback: React.FC<{
	influencerId: string;
	network: string;
	resetErrorBoundary: () => void;
}> = ({ influencerId, network, resetErrorBoundary }) => {
	const { t } = useTranslation();
	const [loading, setLoading] = React.useState(false);
	const handleRetry = async () => {
		setLoading(true);
		try {
			const auditRequest = httpsCallable(fbFunctions, "auditRequest");
			await auditRequest({ influencerId, network });
			resetErrorBoundary();
		} catch (e) {
			// Optionally handle error
		} finally {
			setLoading(false);
		}
	};
	return (
		<Result
			status="error"
			title={t("influencers.auditUnknownErrorTitle")}
			subTitle={t("influencers.auditUnknownErrorSubtitle")}
			extra={
				<Button type="primary" loading={loading} onClick={handleRetry}>
					{t("influencers.retry")}
				</Button>
			}
		/>
	);
};

const AuditErrorBoundary: React.FC<AuditErrorBoundaryProps> = ({
	children,
	influencerId,
	network,
}) => (
	<ErrorBoundary
		FallbackComponent={(props) => (
			<AuditErrorFallback
				{...props}
				influencerId={influencerId}
				network={network}
			/>
		)}
	>
		{children}
	</ErrorBoundary>
);

export default AuditErrorBoundary;
